import React from 'react'
import './Style/Footer.css'
function Footer({paymentInfo}) {
  return <div className='footer px-20 '>


    <div className='flex justify-between items-center mb-4'>

          <div className='Payment-info md:w-5/12 w-full flex justify-between  items-center'>
              <div>
                {paymentInfo.map((item)=>(
                  <p className='Payment md:text-lg text-sm'> {item.label }</p>
                ))}
              </div>
              <div>
                {paymentInfo.map((item)=>(
                  <p className='Payment md:text-lg text-sm'>: {item.value}</p>
                ))}
              </div>
          </div>
        <div className='payment-mgr p-5 text-center ml-2'>
            <p className='md:text-lg text-sm'> Manager </p>
            <p className='md:text-lg text-sm'> #Manager Name </p>
        </div>

    </div>

    <div className='footer-info'>
      <div>
        <h1 className='font-semibold'>  Terms & Conditions  </h1>
        <p className='conditions '> Lorem ipsum dolor sit amet consectetur adipisicing elit. Ex voluptas cum fugit nostrum amet omnis tempora quasi illum aliquam. Maxime harum ex, adipisci dignissimos quaerat iure consequuntur illum cupiditate autem. </p>
        <p className='thanks'> Thank you For Your Business </p>
      </div>
    </div>


  </div>
}

export default Footer